const ALLOWED_ORIGINS = new Set([
	String(process.env.REACT_APP_CREATE_PLATFORM_URL),    // https://create.brandlive(-stage).com
	String(process.env.REACT_APP_GREENROOM_FRONTEND_URL), // https://grenroom.brandlive(-stage).com
	String(process.env.REACT_APP_URL)                     // https://admin.brandlive(-stage).com
]);

if (process.env.REACT_APP_STAGE === 'local') {
	ALLOWED_ORIGINS.add('http://localhost:3000');
	ALLOWED_ORIGINS.add('http://localhost:3002');
}

export default ALLOWED_ORIGINS;
